<template>

    <div>
        <div class="logoMurprotect">
            <img class="backIcon" src="/images/icn_back.png" @click="$router.push('home')" />
            <img src="/images/logo_murprotect.png"/>
        </div>
        <div v-if="showForm" class="newItem">
            <b-field :label="$t('item.email')" class="newName">
                <b-input v-model="form.email"></b-input>
            </b-field>
            <b-field :label="$t('item.pass')" class="newPass">
                <b-input v-model="form.pass"></b-input>
            </b-field>
            <button  v-if="form.id" @click="editItem" :disabled="disabled" class="button is-primary">{{ $t('item.edit') }}</button>
            <button  v-else @click="createItem" :disabled="disabled" class="button is-primary">{{ $t('item.create') }}</button>
            <button  @click="showForm=false" class="button is-primary">{{ $t('item.return') }}</button>
        </div>

        <div v-else class="itemList">
            <div class="newButton">
                <a @click="newForm" class="button is-primary">{{ $t('item.create') }}</a>
            </div>
            <div class="item" v-for="item in users">
                <a class="itemImg">
                    <img src="/images/home/icn_user.png" />
                </a>
                <div class="icons">
                    <a class="itemDelete" @click="confirmDelete(item)"  aria-label="delete">
                      <span class="icon">
                        <i class="fas fa-trash" aria-hidden="true"></i>
                      </span>
                    </a>
                    <a class="itemDelete" @click="editForm(item)"  aria-label="edit">
                      <span class="icon">
                        <i class="fas fa-pen" aria-hidden="true"></i>
                      </span>
                    </a>
                </div>
                <a class="itemName" :href="item.link">
                    <span>{{ item.email }}</span>
                </a>
            </div>
        </div>
    </div>

</template>

<script>
    import firebase from 'firebase/app';
    import {mapState,mapActions} from 'vuex';

    export default {
        components: {},
        name: 'user',
        data() {
            return {
                form: {
                    id: '',
                    email: '',
                    pass: ''
                },
                showForm: false,
            }
        },
        computed: {

            ...mapState('user', {
                users: 'list'
            }),
            disabled: function(){
                return this.form.email.length == 0 || this.form.pass.length == 0;
            }

        },
        methods: {
            ...mapActions('user', {
                delete: 'deleteUser',
                create: 'createUser',
                update: 'updateUser',
            }),

            confirmDelete:function(user) {
                this.$dialog.confirm({
                    title:  this.$t('notification.confirmTitle'),
                    message: this.$t('notification.confirmText'),
                    confirmText: this.$t('notification.accept'),
                    cancelText: this.$t('notification.cancel'),
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => this.deleteItem(user)
                })
            },

            deleteItem: function(user){
                this.delete({id: user[".key"]});
            },
            editItem: function(){
                this.update({data: this.form}).then(() => {
                    this.alertOk();
                }).catch(() =>{
                    this.alertError();
                })
            },
            createItem: function(){
                let user = this.form;
                this.create({user: user}).then(() => {
                    this.alertOk();
                }).catch(() =>{
                    this.alertError();
                });
            },
            editForm: function(item){
                this.form.id = item['.key'];
                this.form.email = item.email;
                this.form.pass = item.pass;
                this.showForm = true;
            },
            newForm: function(){
                this.form.id = '';
                this.form.email = '';
                this.form.pass = '';
                this.showForm = true;
            },
            alertOk: function(){
                this.$dialog.alert(this.$t('notification.ok'))
            },
            alertError: function(){
                this.$dialog.alert({
                    title: 'Error',
                    message: this.$t('notification.error'),
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa'
                })
            }
        }

    }
</script>


<style lang="scss" scoped>

</style>
